export class Topic {
  constructor(
    public name: string,
    public query: string,
    public categoryId: number
  ) {}
}
